import Transformer from './transformer'
import DimensionsTransformer from './dimensions'
import DefaultTransformer from './default'
import WorldUsaTransformer from './world-usa'
import NorthAmericaTransformer from './north-america'
import { scaleLinear as scale } from 'd3-scale'

/*
 * This transformer is used when moving from a 2d feature to a globe. Opposite
 * of the `globe-to-feature`. Had to break it into a separate Transformer
 * b/c the order of operations is very different.
 */
class FeatureToGlobe extends Transformer {

  static match (d0, d1, opts) {
    return (!!d0 &&
        d1.globe) // Now a globe
  }

  constructor (enter, exit, opts) {
    super(enter, exit, opts)

    this.scales = {
      dimension: scale().domain([.5, 1]) // First half of the transition
                       .range([0, 1])
                       .clamp(true),
      feature: scale().domain([0, .5]) // 2nd half of the transition
                     .range([0, 1])
                     .clamp(true)
    }

    // Then we need to determine which transformer we'll use for the 2nd part
    // of the animation. Normally it's just the DefaultTransformer, but if it's
    // USA we need a specific transformer
    let FeatureTransformer = DefaultTransformer

    if (NorthAmericaTransformer.match(enter.datum(), exit.datum(), opts)) {
      // Zooming to North America, so need a special transformer
      FeatureTransformer = NorthAmericaTransformer
    } else if (WorldUsaTransformer.match(enter.datum(), exit.datum(), opts)) {
      // Special transformer, direct to USA
      FeatureTransformer = WorldUsaTransformer
    }

    this.featureTransformer = new FeatureTransformer(enter, exit, opts)

    this.enter = enter
    this.exit = exit
    this.opts = opts
  }

  transform (t) {
    if (t < .5) {
      this.featureTransformer.transform(this.scales.feature(t))
    } else {
      if (!this.dimensionTransformer) {
        // This transformer is used to quickly animate from the 2d map to 3d
        this.dimensionTransformer = new DimensionsTransformer(this.enter, null, Object.assign({}, this.opts, {
          container: this.enter.selection()
        }))
        // Make sure the previous layer isn't visible before we start turning the map into 3d space
        this.exit.remove()
      }
      this.dimensionTransformer.transform(this.scales.dimension(t))
    }
  }

  end () {
    this.dimensionTransformer.end()
  }

}

export default FeatureToGlobe
